export default __webpack_public_path__ + "static/material_02-a27089f7f36e3037d0f5aa38dba4dd5d.png";